<div class="m-1" [class.invalid]="isInvalid()">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label for="{{ effectiveControlId() }}" class="form-label">
            {{ label() }}
            @if (isRequired() || showAsRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
            @if (maxSelect() !== DEFAULT_MAX_SELECT) {
                <fa-icon
                    class="fw-bolder text-warning fs-6"
                    [title]="('common.form.validations.max_allowed_to_select' | translate) + ' ' + maxSelect()"
                    [icon]="['fas', 'circle-info']"
                ></fa-icon>
            }
        </label>
    }

    <ng-select
        class="shadow-sm"
        [class.invalid]="isInvalid()"
        bindLabel="text"
        bindValue="value"
        [multiple]="true"
        [id]="effectiveControlId()"
        [items]="displayOptions"
        [searchable]="searchable()"
        [clearable]="clearable()"
        [formControl]="inputControl"
        [dir]="languageService.direction()"
        [maxSelectedItems]="maxSelect()"
        [placeholder]="inputPlaceholder() | translate"
        (search)="searchChannel$.next($event.term)"
        (ngModelChange)="valueChanged($event)"
    >
        <ng-template ng-option-tmp let-item="item" let-index="index">
            @if (item.value === ALL_Value) {
                <div class="d-flex align-items-center gap-2 fw-bolder text-info" [dir]="languageService.direction()">
                    <input type="checkbox" class="form-check-input m-0 select-all-checkbox" [checked]="isAllSelected()" />
                    <span>{{ item.text }}</span>
                </div>
            } @else {
                <div [dir]="languageService.direction()">{{ item.text }}</div>
            }
        </ng-template>
    </ng-select>
</div>
